import { render, staticRenderFns } from "./TiersInterlocuteurs.vue?vue&type=template&id=22debe71&"
import script from "./TiersInterlocuteurs.vue?vue&type=script&lang=js&"
export * from "./TiersInterlocuteurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports